import firebase from 'firebase';

export const initializeFirebase = () => {
    firebase.initializeApp({
        messagingSenderId: "76887682980"
    });
}

export const askForPermissioToReceiveNotifications = async (afterSuccess) => {
  try {
    const messaging = firebase.messaging();
    await messaging.requestPermission();
    const token = await messaging.getToken();
    // console.log('token do usuário:', token);
    if(afterSuccess) afterSuccess(token);
    
    return token;
  } catch (error) {
    console.error(error);
  }
}


// WEBPACK FOOTER //
// ./src/push-notification.js